import { Fragment } from "react";
import { latexToMathMl, splitLatexText } from "./latex-mathml";
import "./studio-latex-preview.css";
import { formatChemistryText } from './chemical-typography';

/** Render formula segments only; regular text remains escaped by React. */
export function MathText({ text }: { text?: string }) {
  return <>{splitLatexText(text ?? "").map((segment, index) =>
    segment.type === "text" ? <Fragment key={index}>{formatChemistryText(segment.value)}</Fragment> :
      <span key={index} data-studio-math="true"
        className={segment.display ? "studio-math-display" : "studio-math-inline"}
        dangerouslySetInnerHTML={{__html: latexToMathMl(segment.value, segment.display)}} />
  )}</>;
}
